<section id="small-navbar">
  <div class="border-bottom bg-white top-bar">
    <div class="">
      <div class="row align-items-center">
        <div class="col-6 col-md-6">
          <p class="mb-0">
            <a href="tel:4693290962" class="menu-text mr-3"
              ><i class="fas fa-phone icon-item-left hover-view"></i
              ><span class="d-none d-lg-inline-block ml-2"
                >+1 469 329 0962</span
              ></a
            >
            <a href="mailto:info@stridere.com" class="menu-text"
              ><i class="fas fa-envelope icon-item-left hover-view"></i
              ><span class="d-none d-lg-inline-block ml-2"
                >info@stridere.com</span
              ></a
            >
          </p>
        </div>
        <div class="col-6 col-md-6 text-right">
          <a href="https://www.striderealestate.com/ " class="mr-3"
            ><i class="fas fa-globe icon-item-right"></i
          ></a>
          <a href="https://www.facebook.com/striderealestate" class="mr-3"
            ><i class="fab fa-facebook icon-item-right"></i
          ></a>
          <a href="https://twitter.com/RealStride" class="mr-3"
            ><i class="fab fa-twitter icon-item-right"></i
          ></a>
          <a href="https://www.instagram.com/striderealestate" class="mr-3"
            ><i class="fab fa-instagram icon-item-right"></i
          ></a>
          <a
            href="https://www.linkedin.com/company/stride-real-estate"
            class="mr-3"
            ><i class="fab fa-linkedin icon-item-right"></i
          ></a>
          <a href="https://www.pinterest.com/striderealestate/boards/" class=""
            ><i class="fab fa-pinterest icon-item-right"></i
          ></a>
        </div>
      </div>
    </div>
  </div>
</section>
